<template>
  <div>
    <el-dialog
      title="抽取记录"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :modal-append-to-body="true"
      custom-class="draw-dialog"
      width="1200px"
      :destroy-on-close="true"
      @closed="handleClose"
    >
      <table-tem
        :config="tableConfig"
        @changePage="tableChangePage"
        @changePages="changePages"
      >
      </table-tem>
    </el-dialog>
  </div>
</template>
<script>
import tableTem from "@/components/tableTem/index.vue";
export default {
  name: "",
  components: {
    tableTem,
  },
  mixins: [],
  props: {
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialogVisible: false,
      tableConfig: {
        head: [],
        cbHead: [
          {
            type: "index",
            title: "序号",
            align: "center",
            width: 60,
          },
          {
            key: "drawTime",
            title: "抽取时间",
            align: "center",
          },
          {
            key: "ballNumber",
            title: "抽取结果",
            align: "center",
          },
          {
            key: "creator",
            title: "抽取人",
            align: "center",
          },
        ],
        hxrHead: [
          {
            type: "index",
            title: "序号",
            align: "center",
            width: 60,
          },
          {
            key: "drawTime",
            title: "抽取时间",
            align: "center",
          },
          {
            key: "drawStatusText",
            title: "抽取结果",
            align: "center",
          },
          {
            key: "lrr",
            title: "抽取人",
            align: "center",
          },
        ],
        data: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        border: true,
      },
      bdId: "",
      drawStatusEnum: {
        1: "未中签",
        2: "中签",
      },
    };
  },
  computed: {},
  watch: {
    dialogVisible(val) {
      if (val) {
        if (this.type === "cb") {
          this.tableConfig.head = this.tableConfig.cbHead;
        } else if (this.type === "hxr") {
          this.tableConfig.head = this.tableConfig.hxrHead;
        }
        console.log(this.tableConfig.head);
        this.getData();
      }
    },
  },
  created() {
    this.bdId = this.$route.query.bdId;
  },
  mounted() {},
  methods: {
    async getData() {
      this.tableConfig.data = [];
      const para = {
        bdId: this.bdId,
      };
      if (this.type === "cb") {
        this.$api.getCqRecordList(para).then((res) => {
          if (res.data.meta.success) {
            this.tableConfig.data = res.data.data;
          }
        });
      } else if (this.type === "hxr") {
        this.$api.getdrawRecordList(para).then((res) => {
          if (res.data.meta.success) {
            this.tableConfig.data = res.data.data?.map((item) => {
              return {
                ...item,
                drawStatusText: this.drawStatusEnum[item?.drawStatus],
              };
            });
          }
        });
      }
    },
    handleClose() {},
    // 分页功能
    tableChangePage(e) {
      this.tableConfig.currentPage = e;
      this.getData();
    },
    changePages(e) {
      this.tableConfig.pageSize = e;
      this.getData();
    },
  },
};
</script>
<style lang="" scoped></style>
